import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const BackButton: React.FC = () => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate(-1);
  };

  return (
    <IconButton color="primary" aria-label="back" onClick={handleOnClick}>
      <Box display={"flex"} alignItems={"center"}>
        <ArrowBackIosNewRoundedIcon />
        <Typography
          variant="body1"
          style={{ marginLeft: 8, lineHeight: "inherit" }}
        >
          戻る
        </Typography>
      </Box>
    </IconButton>
  );
};

export default BackButton;
